import type { EventInfo } from './interfaces/event-info.interface';
import type { SzebitInNumbers } from './interfaces/szebit-in-numbers.interface';

export const COPYRIGHT_YEAR = '2026';
export const FACEBOOK_EVENT_LINK = 'https://fb.me/e/50KAtGCqd';

export const VIP_SILVER_TOKEN = 'sf3d0dc9-ecde-4628-8acd-6c472da6aa2a';
export const VIP_GOLD_TOKEN = 'g5223a19-bd65-4435-b2dc-dcbdbf4e567c';
export const VipTokens = [VIP_SILVER_TOKEN, VIP_GOLD_TOKEN] as const;
export type VipToken = (typeof VipTokens)[number];

export function eventInfo(): EventInfo {
  return {
    dateHu: '2026.11.12.',
    dateTime: '2026-11-12 9:00',
    dateText: '2026. NOVEMBER 12. (CSÜTÖRTÖK)',
    gateOpening: '9.00-tól',
    openingHours: '9-16.00-ig',
    location: 'SZTE József Attila Tanulmányi és Információs Központ, Szeged',
    masterOfCeremonies: 'Mikos Ákos',
  };
}

export function szebitInNumbers(): SzebitInNumbers {
  return {
    szebitCount: 8,
    visitorsCount: 4000,
    partnersCount: 20,
    daysCount: 1,
  };
}
